/* Builder A · WF-11 shared bits. No new CSS — « obligatoire » uses the
   existing .pill .pill-done classes with no glyph, because the frame draws
   an ink chip with the bare word and Pill’s tone marks are fixed. */
import { Link } from 'react-router-dom'
import { Pill, Skeleton } from '@/ui'

/** « ‹ Messages » — or, for the pages the « E-mails aux clients » tab opens, the way back to that tab (migration pack messages). */
export const Retour = ({ to = '/messages', label = 'Messages' }: { to?: string; label?: string }) => (
  <p className="f-help" style={{ margin: 0 }}><Link to={to}>‹ {label}</Link></p>
)

export const Obligatoire = () => <span className="pill pill-done">obligatoire</span>

/** Read / unread on a private message — the word travels with the mark (F-12). */
export const Lu = ({ read }: { read: boolean }) =>
  read ? <Pill tone="done">lu</Pill> : <Pill tone="warn" mark="●">non lu</Pill>

/** « 5 sept. à 12:12 » — the merchant reads a date, not an ISO string. */
export function quand(at: string): string {
  const d = new Date(at)
  if (Number.isNaN(d.getTime())) return at
  return `${d.toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' })} à ${d.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}`
}

export const Chargement = () => (
  <div style={{ display: 'grid', gap: 10, maxWidth: 720 }}>
    <Skeleton width="42%" /><Skeleton /><Skeleton width="65%" />
  </div>
)
